import { Buffer } from 'buffer';

const reluUrl = "02c3124b7959c96b7f784ac82e021d6b:ef490bea2445549c647d1298ff26d116e3fed343d5abaecf839efadfee1740f4062a47df1636a4a4adfb1c82652d23520cf5b1513a45fe56063550d74fa12327767e48ede4c992502d37a64b4d0b3004e4dfefc128b3dd98ea12d1be7cdc7a2209b41bcb440d7ea282db7054fc664164a6aeaf4680b901d0617d5abb57a6098605f5b0b6994eeb8078789466d4414eee25f0a90f39781f79a76eab642b41710264121be9f4ad665d440caa626d9d547213ad8852c0197c20e96b0c02d4ed2d1e7e6b2f83b7a17a0f4ded0f711c3f7907865c837827a678dae8f6f5e7a4d994c7d8eefc647e4340d652280417f263e1dee129dfeed630a611464bc102ba7c6e40a635e58300e7b1a3d5115c6146439ac3d5ca0341414bf3f64aad4da58fe395a8ac51f60795818bb41d329d18fa3bb4d4015ed44d5788c70cf9ab3db2202c9b950182e38ae5e58eda7b89534cb86bf32ad4028074d3979b842bb33a8e3a242fe5";

function stringToKey(str) {
    const key = new Uint8Array(32);
    const encoder = new TextEncoder();
    const strBytes = encoder.encode(str);
    
    for (let i = 0; i < 32; i++) {
        key[i] = strBytes[i % strBytes.length];
    }
    
    return btoa(String.fromCharCode.apply(null, key));
}

function getKey(options = { initialBase64Key: undefined }) {
  const base64Key = options.initialBase64Key ?? '5HluFy9CiYJunjmPXK7oin82Zkf532w4omsIvUFMqp8=';
  const key = Buffer.from(base64Key, 'base64');
  return key;
}

async function encrypt(text, options = { initialBase64Key: undefined }) {
  const key = getKey(options);
  const iv = crypto.getRandomValues(new Uint8Array(16));
  const encoder = new TextEncoder();
  const data = encoder.encode(text);

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    key,
    { name: 'AES-CBC', length: 256 },
    false,
    ['encrypt']
  );

  const encrypted = await crypto.subtle.encrypt({ name: 'AES-CBC', iv }, cryptoKey, data);

  const encryptedArray = new Uint8Array(encrypted);
  const ivHex = Array.from(iv)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  const encryptedHex = Array.from(encryptedArray)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return ivHex + ':' + encryptedHex;
}

async function decrypt(encryptedText, options = { initialBase64Key: undefined }) {
  const key = getKey(options);
  const textParts = encryptedText.split(':');
  const iv = new Uint8Array(textParts[0].match(/.{1,2}/g).map((byte) => parseInt(byte, 16)));
  const encrypted = new Uint8Array(textParts[1].match(/.{1,2}/g).map((byte) => parseInt(byte, 16)));

  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    key,
    { name: 'AES-CBC', length: 256 },
    false,
    ['decrypt']
  );

  const decrypted = await crypto.subtle.decrypt({ name: 'AES-CBC', iv }, cryptoKey, encrypted);

  const decoder = new TextDecoder();
  return decoder.decode(decrypted);
}

export const rtCrypt = {
  encrypt,
  decrypt,
  stringToKey,
  reluUrl
};
